export default __webpack_public_path__ + "static/media/blur-leaf-2.69ab73d1.png";